module.exports = __webpack_public_path__ + "img/root001.56010997.png";